import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerStatementRunReviewLinesQueryVariables = Types.Exact<{
  runId: Types.Scalars['String']['input'];
}>;


export type GetCustomerStatementRunReviewLinesQuery = { __typename?: 'Query', customerStatementRunReviewLines: Array<{ __typename?: 'CustomerStatementRunOutcomeData', accruedLateCharge: number, closingBalance: number, customerId: string, customerName: string, disposition: Types.CustomerStatementRunDisposition, reason: string, recipients: Array<string>, routed: boolean, sent: boolean, waivedLateCharge: number }> };

export type GetCustomerStatementRunsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerStatementRunDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerStatementRunDocumentSortInput> | Types.CustomerStatementRunDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerStatementRunsQuery = { __typename?: 'Query', customerStatementRuns?: { __typename?: 'CustomerStatementRunsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerStatementRunDocument', completedAt: Types.TDateISO, periodEndExclusive: Types.TDateISO, periodStart: Types.TDateISO, reportId: string, routedCount: number, runId: string, sentCount: number, skippedCount: number, status: Types.CustomerStatementRunStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerStatementPreviewQueryVariables = Types.Exact<{
  runId: Types.Scalars['String']['input'];
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerStatementPreviewQuery = { __typename?: 'Query', customerStatementPreview: { __typename?: 'ReportPdfPayload', errorMessage?: string | null, pdfBase64?: string | null, success: boolean } };

export type GetCustomersStatementDeliveryEffectiveQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomersStatementDeliveryEffectiveQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetStatementPrintBatchQueryVariables = Types.Exact<{
  statementRunId: Types.Scalars['String']['input'];
}>;


export type GetStatementPrintBatchQuery = { __typename?: 'Query', statementPrintBatch: { __typename?: 'StatementPrintBatchPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, printBatch?: { __typename?: 'StatementPrintBatchDocument', downloadUrl?: string | null, failureReason?: string | null, printBatchId: string, renderedCount: number, statementRunId: string, status: Types.StatementPrintBatchStatus, statements: Array<{ __typename?: 'StatementPrintBatchItemDocument', customerId: string }> } | null } };

export type CustomerStatementRunFragment = { __typename?: 'CustomerStatementRunData', routedCount: number, runId: string, sentCount: number, skippedCount: number, status: Types.CustomerStatementRunStatus };

export type CustomerStatementRunSummaryFragment = { __typename?: 'CustomerStatementRunDocument', completedAt: Types.TDateISO, periodEndExclusive: Types.TDateISO, periodStart: Types.TDateISO, reportId: string, routedCount: number, runId: string, sentCount: number, skippedCount: number, status: Types.CustomerStatementRunStatus };

export type StatementPrintBatchFieldsFragment = { __typename?: 'StatementPrintBatchDocument', downloadUrl?: string | null, failureReason?: string | null, printBatchId: string, renderedCount: number, statementRunId: string, status: Types.StatementPrintBatchStatus, statements: Array<{ __typename?: 'StatementPrintBatchItemDocument', customerId: string }> };

export const CustomerStatementRunFragmentDoc = new TypedDocumentString(`
    fragment CustomerStatementRun on CustomerStatementRunData {
  routedCount
  runId
  sentCount
  skippedCount
  status
}
    `, {"fragmentName":"CustomerStatementRun"});
export const CustomerStatementRunSummaryFragmentDoc = new TypedDocumentString(`
    fragment CustomerStatementRunSummary on CustomerStatementRunDocument {
  completedAt
  periodEndExclusive
  periodStart
  reportId
  routedCount
  runId
  sentCount
  skippedCount
  status
}
    `, {"fragmentName":"CustomerStatementRunSummary"});
export const StatementPrintBatchFieldsFragmentDoc = new TypedDocumentString(`
    fragment StatementPrintBatchFields on StatementPrintBatchDocument {
  downloadUrl
  failureReason
  printBatchId
  renderedCount
  statementRunId
  statements {
    customerId
  }
  status
}
    `, {"fragmentName":"StatementPrintBatchFields"});
export const GetCustomerStatementRunReviewLinesDocument = new TypedDocumentString(`
    query GetCustomerStatementRunReviewLines($runId: String!) {
  customerStatementRunReviewLines(runId: $runId) {
    accruedLateCharge
    closingBalance
    customerId
    customerName
    disposition
    reason
    recipients
    routed
    sent
    waivedLateCharge
  }
}
    `);
export const GetCustomerStatementRunsDocument = new TypedDocumentString(`
    query GetCustomerStatementRuns($where: CustomerStatementRunDocumentFilterInput, $order: [CustomerStatementRunDocumentSortInput!], $first: Int) {
  customerStatementRuns(where: $where, order: $order, first: $first) {
    nodes {
      ...CustomerStatementRunSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CustomerStatementRunSummary on CustomerStatementRunDocument {
  completedAt
  periodEndExclusive
  periodStart
  reportId
  routedCount
  runId
  sentCount
  skippedCount
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerStatementPreviewDocument = new TypedDocumentString(`
    query GetCustomerStatementPreview($runId: String!, $customerId: String!) {
  customerStatementPreview(runId: $runId, customerId: $customerId) {
    errorMessage
    pdfBase64
    success
  }
}
    `);
export const GetCustomersStatementDeliveryEffectiveDocument = new TypedDocumentString(`
    query GetCustomersStatementDeliveryEffective($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      effectiveStatementDeliveryMethod
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetStatementPrintBatchDocument = new TypedDocumentString(`
    query GetStatementPrintBatch($statementRunId: String!) {
  statementPrintBatch(statementRunId: $statementRunId) {
    errors {
      code
      message
    }
    printBatch {
      ...StatementPrintBatchFields
    }
  }
}
    fragment StatementPrintBatchFields on StatementPrintBatchDocument {
  downloadUrl
  failureReason
  printBatchId
  renderedCount
  statementRunId
  statements {
    customerId
  }
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerStatementRunReviewLines: build.query<GetCustomerStatementRunReviewLinesQuery, GetCustomerStatementRunReviewLinesQueryVariables>({
      query: (variables) => ({ document: GetCustomerStatementRunReviewLinesDocument, variables })
    }),
    GetCustomerStatementRuns: build.query<GetCustomerStatementRunsQuery, GetCustomerStatementRunsQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerStatementRunsDocument, variables })
    }),
    GetCustomerStatementPreview: build.query<GetCustomerStatementPreviewQuery, GetCustomerStatementPreviewQueryVariables>({
      query: (variables) => ({ document: GetCustomerStatementPreviewDocument, variables })
    }),
    GetCustomersStatementDeliveryEffective: build.query<GetCustomersStatementDeliveryEffectiveQuery, GetCustomersStatementDeliveryEffectiveQueryVariables | void>({
      query: (variables) => ({ document: GetCustomersStatementDeliveryEffectiveDocument, variables })
    }),
    GetStatementPrintBatch: build.query<GetStatementPrintBatchQuery, GetStatementPrintBatchQueryVariables>({
      query: (variables) => ({ document: GetStatementPrintBatchDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerStatementRunReviewLinesQuery, useLazyGetCustomerStatementRunReviewLinesQuery, useGetCustomerStatementRunsQuery, useLazyGetCustomerStatementRunsQuery, useGetCustomerStatementPreviewQuery, useLazyGetCustomerStatementPreviewQuery, useGetCustomersStatementDeliveryEffectiveQuery, useLazyGetCustomersStatementDeliveryEffectiveQuery, useGetStatementPrintBatchQuery, useLazyGetStatementPrintBatchQuery } = injectedRtkApi;
